<template>
    <div id="aboutusDiv">
        
        <ul class="side-menu">
            <li>
                <router-link to="/about-us">About Us </router-link>
            </li>
            <li>
                <router-link to="/contact-us">Contact Us</router-link>
            </li>
            <li>
                <router-link to="/privacy-policy">Privacy Policy</router-link>
            </li>
            <li>
                <router-link to="/terms">Terms & Conditions</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'Sidemenu',
  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.router-link-exact-active, .router-link-active {
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/web/Public/Sidemenu.vue